import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';
import { useTaxes } from '@/data/tax';
import NotFound from '@/components/common/NotFound';
import LoadingPage from '@/components/common/LoadingPage';
import AddTaxDialog from './components/AddTaxDialog';
import TaxRow from './components/TaxRow';

const TaxListPage = () => {
  const taxes = useTaxes();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Tax Rates
          <AddTaxDialog />
        </CardTitle>
        <CardDescription>
          Manage tax rates. Tax rates can be applied to regions.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {taxes.data.length === 0 ? (
          <NotFound title="No Taxes Found" />
        ) : (
          <>
            <Card>
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Name</TableHead>
                    <TableHead>Label</TableHead>
                    <TableHead className="text-right">Rate</TableHead>
                    <TableHead />
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {taxes.data.map((tax) => (
                    <TaxRow key={tax.id} tax={tax} />
                  ))}
                </TableBody>
              </Table>
            </Card>
            <div className="text-center p-4">
              <span className="text-sm text-muted-foreground">
                Total: {taxes.data.length}
              </span>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
};

const TaxListPageLoader = () => {
  const taxes = useTaxes();

  if (taxes.isLoading && !taxes.data) {
    return <LoadingPage />;
  }

  return <TaxListPage />;
};

export default TaxListPageLoader;
